import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { createContext, useContext } from 'react';
import { useErrorBoundary } from 'react-error-boundary';
import { Outlet, useParams } from 'react-router-dom';
import { getOneProject } from 'services/title-report/project';

const ProjectContext = createContext<UseQueryResult<
    Ether.TitlesReport.IProject,
    Error
> | null>(null);

const ProjectSubpages = () => {
    const errorBoundary = useErrorBoundary();

    const params = useParams<{
        projectOid: string;
    }>() as { projectOid: string };

    const projectQuery = useQuery<Ether.TitlesReport.IProject, Error>(
        ['get-one-project', params.projectOid],
        async ({ signal }): Promise<Ether.TitlesReport.IProject> => {
            const data = await getOneProject(params.projectOid, { signal });
            if (data == null) throw new Error('Project not found');
            return data;
        },
        {
            onError: (err) => errorBoundary.showBoundary(err),
        }
    );

    return projectQuery.status === 'loading' ? (
        <h2>Loading project info...</h2>
    ) : (
        <ProjectContext.Provider value={projectQuery}>
            <Outlet />
        </ProjectContext.Provider>
    );
};

export const useProjectQuery = () => {
    const context = useContext(ProjectContext);
    return context;
};

export default ProjectSubpages;
